export default [
  {
    title: 'How long is the obligation?',
    heading: 'Home Security',
    slug: 'how-long-is-the-obligation/',
    date: 'April 27, 2022',
    content: '<p>Obligations run 5 years for homeowners and 3 years for tenant renters. Agreements are open-ended and can be customized to fit your needs.</p>'
  },
  {
    title: 'What is the rate for monitoring?',
    heading: 'Home Security',
    slug: 'what-is-the-rate-for-monitoring/',
    date: 'April 27, 2022',
    content: "<p>Slomin's monitoring rates start at $33.95* per-month, with upgraded options always available.</p>"
  },
  {
    title: 'Do I need a phone line in the house?',
    heading: 'Home Security',
    slug: 'do-i-need-a-phone-line-in-the-house/',
    date: 'April 27, 2022',
    content: "<p>No. Slomin's uses wireless cellular connection to commuicate with our central monitoring station, so you don't need a landline phone to use your system.</p>"
  },
  {
    title: 'What equipment do I get in the free system?',
    heading: 'Home Security',
    slug: 'what-do-i-get-in-the-free-system/',
    date: 'April 27, 2022',
    content: "<p>The Slomin's Shield® home security system includes: Panel and Keypad, 3 Door Motion Detectors, Battery Back-up, Yard Signs and Window Decals; all provided with a free in-home security review and professional installation.</p>"
  },
  {
    title: 'Do you monitor all the windows?',
    heading: 'Home Security',
    slug: 'do-you-monitor-all-the-windows/',
    date: 'April 27, 2022',
    content: "<p>Our basic system arms up to 3 doors, providing the most comprehensive protection for your home. You can always speak to a Slomin's home security representative about additional features you may be interested in.</p>"
  },
  {
    title: 'Do you need to drill holes in my house to install the alarm system?',
    heading: 'Home Security',
    slug: 'do-you-need-to-drill-holes-in-my-house-to-install-the-alarm-system/',
    date: 'April 27, 2022',
    content: "<p>In order to properly install your system, Slomin's is authorized to make the necessary preparations such as drilling holes, driving nails, and making attachments.</p>"
  },
  {
    title: 'Can I operate the alarm system from my phone and can I know when someone turns the system on or off?',
    heading: 'Home Security',
    slug: 'can-i-operate-the-alarm-system-from-my-phone-and-can-i-know-when-someone-turns-the-system-on-or-off/',
    date: 'April 27, 2022',
    content: "<p>Yes. With the MySlomin's App for Apple and Android, you can operate and manage your system devices from virtually anywhere with internet connection directly from your mobile device or tablet.</p>"
  },
  {
    title: 'Do the cameras record?',
    heading: 'Home Security',
    slug: 'do-the-cameras-record/',
    date: 'April 27, 2022',
    content: "<p>Yes. All of our indoor and outdoor HD cameras feature 24/7 video recording functionality; with up to 5 days on-board video storage and 15 days cloud storage. Events are typically captured in 15-30 second video clips depending on motion, all of which can be downloaded.</p>"
  },
  {
    title: 'Do the cameras see in the dark?',
    heading: 'Home Security',
    slug: 'do-the-cameras-see-in-the-dark/',
    date: 'April 27, 2022',
    content: "<p>Yes - all of our cameras use ambient light functionality to deliver a clear image, day and night.</p>"
  },
  {
    title: 'Who do I call if I need assistance with my alarm system?',
    heading: 'Home Security',
    slug: 'who-do-i-call-if-i-need-assistance-with-my-alarm-system/',
    date: 'April 27, 2022',
    content: "<p>Please call our office at 1-800-ALARM-ME for all alarm system-related assistance, inquiries, or if you're concerned with a technician's status. We are always happy to help you.</p>"
  },
  {
    title: 'How long does an installation take?',
    heading: 'Home Security',
    slug: 'how-long-does-an-installation-take/',
    date: 'April 27, 2022',
    content: "<p>Our basic alarm system installations typically take 3-4 hours. It's also important to note additional factors such as the size of your home, equipment type, and purchase specifics will determine exactly how long the install will take. Most of our alarm system installations are complete within 1 day.</p>"
  },
  {
    title: 'I didn’t know I signed up for a 5-year contract. Now what?',
    heading: 'Home Security',
    slug: 'i-didnt-know-i-signed-up-for-a-5-year-contract-now-what/',
    date: 'April 27, 2022',
    content: "<p>Whether its with Slomin’s or any other company/individual, it's extremely important to make sure you fully read and understand the agreement of which you're signing for. Slomin’s rewards a $1,145.00 home security system - free of charge - to customers who sign up for five years of central monitoring. If you break your end of the contract, Slomin’s has no way of compensating for the loss on equipment. In essence, if you sign a contract then decide that you no longer wish to protect your home with central monitoring, you remain accountable for the outstanding balance listed on your contract.</p>"
  },
  {
    title: 'Why is my smoke detector beeping/chirping?',
    heading: 'Home Security',
    slug: 'why-is-my-smoke-detector-beeping-chirping/',
    date: 'April 27, 2022',
    content: "<p>Only Slomin's hardwired smoke detectors will beep/chirp, indicating that your device's battery is low. When it does, simply twist the bottom to open your device and replace the batteries with new ones. Any other smoke detectors DO NOT 'beep or chirp'. Perhaps you have an old battery powered smoke detector that is not part of your Slomin's alarm system and its battery is running low. If you have a wireless Slomin's smoke detector and the battery is running low, your touchscreen keypad will display a 'low battery' light.</p>"
  },
  {
    title: 'I have a dog. Why do I need an alarm system?',
    heading: 'Home Security',
    slug: 'i-have-a-dog-why-do-i-need-an-alarm-system/',
    date: 'April 27, 2022',
    content: "<p>While a dog can protect you when you're home, it takes a Slomin’s Shield home security system to safeguard your pup for when you aren’t. Unfortunately, burglars are ruthless and often willing to harm whatever's standing in their way of gaining access to your home. In the event of a house fire, Slomin’s fire protection offers immediate response to your signal in order to help protect your pets at home. Like our burglary protection, Slomin's fire safety and other protection services are all connected to our central monitoring station, allowing us to contact you immediately and respond effectively if something goes wrong.</p>"
  },
  {
    title: 'I have a pet, can I use the motion detector?',
    heading: 'Home Security',
    slug: 'i-have-a-pet-can-i-use-the-motion-detector/',
    date: 'April 27, 2022',
    content: "<p>Yes. Our motion detectors contain several options to avoid and control sensor sensitivity so that your pets can wander freely throughout the home--all of which you can discuss in further detail with any Slomin's technician. Detectors typically allow for pets up to 30 lbs. and for larger animals, pet alleys can also be set up.</p>"
  },
  {
    title: 'How long does a heating installation take?',
    heading: 'Heating',
    slug: 'how-long-does-a-heating-installation-take/',
    date: 'April 27, 2022',
    content: "<p>Heating installations typically take 4-8 hours. It's also important to note factors like the size of your home, equipment type, and purchase specifics that'll determine exactly how long the install will take. Most heating installations are complete within 1 day.</p>"
  },
  {
    title: 'How long does a cooling installation take?',
    heading: 'Cooling',
    slug: 'how-long-does-a-cooling-installation-take/',
    date: 'April 27, 2022',
    content: "<p>AC Cooling installations typically take anywhere from 8-20 hours, or 2 days on average. It's also important to note factors like the size of your home, equipment type, and purchase specifics that'll determine exactly how long the install will take. Most cooling installations are complete within 2 days.</p>"
  },
  {
    title: 'Ultimate plan for 49 95 ',
    heading: 'Heating',
    slug: 'ultimate-plan-for-49-95/',
    date: 'April 27, 2022',
    content: "<ul><li>Incl. Features of Standard Plan Plus</li><li>Lifetime Service on Equipment</li><li>Remote Access to system</li><li>Mobile Alerts</li><li>Control of Smart Home Devices</li><li>Live Camera Viewing</li><li>Motion Triggered Clips &amp; Recording</li></ul><span>Monitoring charges will be billed monthly and requires customer to be on auto pay. 5-Year Commitment Required; Charges billed month to month thereafter.</span>"
  },
  {
    title: 'Standard plan for 33 95',
    heading: 'Heating',
    slug: 'standard-plan-for-33-95/',
    date: 'April 27, 2022',
    content: "<ul><li>24/7 live professional monitoring</li><li>Cellular communication</li><li>32 user codes available</li><li>View event history on keypad</li><li>System can be expanded</li><li>24 hour battery backup</li><li>One year equipment warranty</li></ul><span>Monitoring charges will be billed monthly and requires customer to be on auto pay. 5-Year Commitment Required; Charges billed month to month thereafter.</span>"
  },
  {
    title: 'How much will I be charged for a service call?',
    heading: 'Home Security',
    slug: 'how-much-will-i-be-charged-for-a-service-call/',
    date: 'April 27, 2022',
    content: "<p>With most calls accounted for under our service plans, it's important to reference your own in order to see exactly what is and isn't covered. If you choose to opt out of a Slomin's service plan, you'll be billed for the time and materials used during the call.</p>"
  },
  {
    title: 'How can I test my alarm?',
    heading: 'Home Security',
    slug: 'how-can-i-test-my-alarm/',
    date: 'April 27, 2022',
    content: "<p>Please visit your <a href='http://mya.slomins.com/account/Index' target='_blank'>MySlomin's Account Portal</a> for specific instructions to test your alarm.&nbsp; For further assistance, please call <strong>1-866-756-6467</strong>.</p>"
  },
  {
    title: 'How do I pay my bill? What forms of payment do you accept?',
    heading: 'Billing',
    slug: 'how-do-i-pay-my-bill-what-forms-of-payment-do-you-accept/',
    date: 'April 27, 2022',
    content: "<p>The easiest way to pay and manage your bill is via your <a href='https://mya.slomins.com/Account/Index'>MySlomin's Account Portal</a>.&nbsp; You can ensure your billing information is correct, set up automatic payments, add or change a credit card, and more. <strong>To make a payment over the phone</strong>, call 1-800-252-7663. <strong>To mail your payment</strong>, please address to: Slomin’s Inc. 125 Lauman Lane Hicksville, NY 11801</p>"
  },
  {
    title: 'What if I move?',
    heading: 'Home Security',
    slug: 'what-if-i-move/',
    date: 'April 27, 2022',
    content: "<p>Slomin's helps ensure you enjoy the same trusted protection at your new home.  If you're planning to relocate, here's what you can do:</p><ul><li><b>Bring your system equipment into your new home and continue the same service.&nbsp;&nbsp;</b>If you are not capable of installing the system in your new home, we'll send over a trained technician to do it for you at a minimal fee.</li><li><b>Leave your system behind for the new homeowners.</b>&nbsp; Slomin’s will install a brand new system and continue the agreement to monitor the system.</li><li><b>Transfer your current agreement over to the new homeowner, then install a brand new system and new agreement to your next place for free.</b>&nbsp; *Please be advised that additional required fees may vary depending on location.</li></ul>"
  },
  {
    title: 'What does it cost to cancel?',
    heading: 'Home Security',
    slug: 'what-does-it-cost-to-cancel/',
    date: 'April 27, 2022',
    content: "<p>If you wish to cancel your account, please call <strong>1-866-756-6467</strong> to speak with an in-house specialist and review your options.</p>"
  },
  {
    title: 'Can you takeover my existing alarm?',
    heading: 'Home Security',
    slug: 'can-you-takeover-my-existing-alarm/',
    date: 'April 27, 2022',
    content: "<p>Our home security specialists will fully examine your existing alarm system during your free at-home consultation. In most cases, we can have your current system adapt to ours.</p>"
  },
  {
    title: 'Can I view the cameras off site?',
    heading: 'Home Security',
    slug: 'can-i-view-the-cameras-off-site/',
    date: 'April 27, 2022',
    content: "<p>Yes. You can access and manage your system devices from anywhere with internet connection via The MySlomin's App.</p>"
  },
  {
    title: 'What happens when I submit a payment that’s more than the monthly amount to My Account?',
    heading: 'Billing',
    slug: 'what-happens-when-i-submit-a-payment-thats-more-than-the-monthly-amount-to-my-account/',
    date: 'April 27, 2022',
    content: "<p>For account payments exceeding the charged amount, you can either:</p><ul><li>Apply the remaining credit to your next invoice.</li><li>Request the credit be refunded to you.</li></ul>"
  },
  {
    title: 'If someone in my home is deaf, how will they know if the alarm is going off? How can they communicate with central station?',
    heading: 'Home Security',
    slug: 'there-is-someone-in-the-house-that-is-deaf-how-will-they-know-if-the-alarm-is-going-off-how-can-they-communicate-with-central-station/',
    date: 'April 27, 2022',
    content: "<p>Slomin's home security systems contain sensory alerts, strobe lights, and other customizable settings for deaf and hard of hearing households.  Our central monitoring station also uses Telecommunications Relay Services (TTY/TRS) to facilitate calls between persons who are deaf, hard of hearing, or have speech disabilities and other individuals.</p>"
  },
  {
    title: 'Can I change my billing date?',
    heading: 'Billing',
    slug: 'can-i-change-my-billing-date/',
    date: 'April 27, 2022',
    content: '<p>You can update your account, billing details, and more by logging into <a href="https://mya.slomins.com/Account/Index" target="_blank">MYA.slomins.com</a> and selecting "Account Overview".&nbsp; For further assistance, please <strong>1-866-756-6467</strong>.</p>'
  },
  {
    title: 'Where can I find a copy of my alarm system owner’s manual?',
    heading: 'Home Security',
    slug: 'where-can-i-find-a-copy-of-my-alarm-system-owners-manual/',
    date: 'April 27, 2022',
    content: '<p>Your system-specific manual can be found via your Account Portal.  Just follow these steps:</p><ol><li>Visit <a href="http://mya.slomins.com/account/Index" target="_blank">MYA.slomins.com</a> and log into your account.</li><li>Select the "Account Overview" tab.</li><li>Tap "Security Account" <strong>&gt;</strong> "System Troubleshooting".</li><li>At the top of the page, select the red icon next to "View your systems Owners Manual for a complete guide to your equipment".</li><li>View/download a PDF copy of your manual.</li></ol>'
  },
  {
    title: 'My keypad display says “low battery”. What should I do?',
    heading: 'Home Security',
    slug: 'my-display-says-there-is-no-power-to-the-system/',
    date: 'April 27, 2022',
    content: "<p>If low battery is displayed on your keypad, here are some common causes and how to fix it:</p><ul><li><strong>Your house does not have power, or recently lost power. </strong>In cases like this, your system will continue to operate on battery back up until it runs out. Once power is restored in the home, the battery will recharge automatically and restore your system once finished.&nbsp; *Please allow a 24-hour period for the battery to fully recharge.</li><li><strong>The system transformer is unplugged.&nbsp;</strong> Check to see that your alarm panel transformer is securely plugged in.&nbsp; If not, plug it back in.</li><li><strong>Faulty power source.&nbsp;</strong> If the alarm panel transformer is plugged in, check to see if there's any power coming from the outlet itself by plugging in another appliance and see if it works.&nbsp; If not, check the appropriate circuit breaker that the outlet is connected to.&nbsp; If your breaker is functioning - schedule a service call from a Slomin’s technician.&nbsp; If your breaker if not functioning - <span>you’ll need to call an electrician.</span></li><li><strong>Your battery needs to be replaced.</strong> Replacement batteries can be purchased from Slomin's for $25 and mailed to you with installation instructions. You can also request a service call and have one of our technicians replace it. (If you choose this option, you'll be charged for time and materials.) Finally, you can call for the battery’s specifications and purchase a replacement from a retail store.</li></ul>"
  },
  {
    title: 'Is there a penalty for false alarms?',
    heading: 'Home Security',
    slug: 'is-there-a-penalty-for-false-alarms/',
    date: 'April 27, 2022',
    content: "<p>Slomin's will not penalize you for false alarms and will always call and ask your verified passcode before dispatching any authorities.  However, it is the homeowners responsibility to check with their local officials, businesses, etc. regarding false alarm fines for their area.</p>"
  },
  {
    title: 'How long is the warranty?',
    heading: 'Home Security',
    slug: 'how-long-is-the-warranty/',
    date: 'April 27, 2022',
    content: "<p>In the event that any part of your security equipment is defective, our services include a 1-year manufacturers warranty with opportunity to extend. Effective on the date of installation, Slomin's agrees to make all repairs and replacement of parts during this time without cost to the subscriber.</p>"
  },
  {
    title: 'Can customer referral credits be transferred to a different account?',
    heading: 'Billing',
    slug: 'can-my-referral-credit-be-transferred-to-another-slomins-bill-or-customer/',
    date: 'April 27, 2022',
    content: "<p>Credits cannot be transferred to a separate bill or customer, and can only be used under the account who generated the referral.</p>"
  },

];